// Angular imports
import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

// Local imports
import { StepInfo } from '../../interface/steps-info';
import { ContactInfo } from '../../enum/contact-info';

@Component({
  selector: 'tgx-onboarding-company-contacts-steps',
  templateUrl: './onboarding-company-contacts-steps.component.html',
  styleUrls: ['./onboarding-company-contacts-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OnboardingCompanyContactsStepsComponent implements OnChanges {
  progressBar = 10;
  position: StepInfo[] = [];
  @Input() steps: Map<ContactInfo, StepInfo<ContactInfo>>;
  @Input() isBuyer: boolean;
  @Input() isSeller: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['steps'] && changes['steps'].currentValue) {
      this.updateProgress();
    }
  }

  private updateProgress(): void {
    this.position = [];
    this.steps.forEach((stepInfo) => {
      if (stepInfo.actualStep) {
        this.progressBar = stepInfo.width;
      }

      if (!stepInfo.hidden) {
        this.position.push(stepInfo);
      }
    });
  }
}
